"use client";

/**
 * Workstream 0 — captures ad click IDs on every navigation and exposes them as
 * persistent GTM Data Layer Variables.
 *
 * Renders nothing. Mounted once in the root layout so it runs on every route:
 * a visitor can land on an ad URL anywhere, not just the home page.
 *
 * Exposing the ids as dataLayer variables (rather than attaching them to each
 * event) means every GA4 event resolves them through the container's existing
 * variables, including events fired by code that knows nothing about
 * attribution. Only ids actually present are pushed, so an organic visit leaves
 * the variables unset rather than blank.
 */
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import {
    captureParams,
    getAttribution,
    DATALAYER_VARS,
} from "@/utils/attribution";
import { setDataLayerVars } from "@/utils/tracking";

export default function AttributionCapture() {
    const pathname = usePathname();

    useEffect(() => {
        captureParams(window.location.search, window.location.href);

        const attr = getAttribution();
        const vars = Object.fromEntries(
            DATALAYER_VARS.filter((k) => attr[k]).map((k) => [k, attr[k]]),
        );
        setDataLayerVars(vars);
    }, [pathname]);

    return null;
}
